export const iconFontAwesomeMedicalHealthHouseMedicalCircleXmark = (
	<i className="fa-solid fa-house-medical-circle-xmark"></i>
);
